import { Box, Typography, useTheme } from "@mui/material";
import { productsAndServices } from "../../data/products-and-services";
import { SectionTitles } from "../../data/texts";
import { Icons } from "../../models/assets-files";
import ActionCard from "../common/ActionCard";
import { ImageService } from "../../services/image.service";
import useScreen from "../common/UseScreen";

interface ProductsAndServicesProps {
  onProductSelect: (href: string) => void;
}

const ProductsAndServices = ({ onProductSelect }: ProductsAndServicesProps) => {
  const theme = useTheme();
  const { isDesktop } = useScreen();
  return (
    <Box sx={{ paddingInline: isDesktop ? "" : "10px" }}>
      <Typography
        sx={{
          color: theme.palette.primary.main,
          fontSize: "18px",
          fontWeight: "600",
          marginBottom: "16px",
        }}
      >
        {SectionTitles.PRODUCTS_AND_SERVICES}
      </Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "16px",
          flexWrap: "wrap",
        }}
      >
        {productsAndServices.map((item) => (
          <ActionCard
            handleButtonClick={() => onProductSelect(item.href)}
            key={item.id}
            containerSx={{
              flexGrow: "1",
              width: "213px",
              boxShadow: theme.custom.cardBoxShadow,
            }}
            imageSrc={ImageService.getLocalIconPath(
              Icons.Folders.PRODUCTS_AND_SERVICES,
              item.icon
            )}
            title={item.title}
            button={item.button}
          />
        ))}
      </Box>
    </Box>
  );
};

export default ProductsAndServices;
